var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortArrowIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37408 0.469669C6.08119 0.176776 5.60631 0.176776 5.31342 0.469669L0.54045 5.24264C0.247556 5.53553 0.247556 6.01041 0.54045 6.3033C0.833343 6.59619 1.30822 6.59619 1.60111 6.3033L5.84375 2.06066L10.0864 6.3033C10.3793 6.59619 10.8542 6.59619 11.1471 6.3033C11.4399 6.01041 11.4399 5.53553 11.1471 5.24264L6.37408 0.469669ZM6.59375 16L6.59375 0.999999L5.09375 0.999999L5.09375 16L6.59375 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowIcon);
export default __webpack_public_path__ + "static/media/SortArrowIcon.cd5a983711b5e6b5d1df30e7cb506fbd.svg";
export { ForwardRef as ReactComponent };